//Load basicLightbox as a module
const basicLightbox = require('basiclightbox');

const lightbox = () => {
  const lightboxes = document.querySelectorAll('a.basic-lightbox');
  if (lightboxes) {
    lightboxes.forEach((lightbox) => {
      lightbox.onclick = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const imgsrc = event.currentTarget.href;
        basicLightbox.create('<img src="' + imgsrc + '">').show();
      };
    });
  }
};

export { lightbox };
